import React, { useState, useEffect } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

import Styles from "./Collapse.module.scss";

export const Collapse = ({
  id, 
  className, 
  children, 
  activeClassName
}) => {
  const [ show, setShow ] = useState(false);

  let _attr = {},
      _classes = (className) ? className : null;
  
  if (id) _attr.id = id;
  _attr.className = classnames(
    {
      [Styles["collapse"]]: true,
      [Styles["show"]]: show
    },
    _classes,
    (show) ? activeClassName || "show" : null
  );

  const toggle = () => {
    setShow(!show);
  };

  const Arrow = () => {
    return (show === true) 
      ? <i className={"fas fa-angle-double-up"}/> 
      : <i className={"fas fa-angle-double-down"}/>;
  };

  return (
    <div {..._attr} onClick={toggle}>
      <section>
        {children}
      </section>
      <button >
        <Arrow/>
      </button>
    </div>
  );
};

Collapse.defaultProps = {
  id: null,
  className: null,
  children: null,
  activeClassName: null
};

Collapse.propTypes = {
  id: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  children: PropTypes.node,
  activeClassName: PropTypes.string
};
